<template>
  <v-app id="checkout">
    <v-container class="pa-0" fluid @mouseleave="onLeave">
      <progress-bar
        :show="this.loading"
        color="orange"
        type="full"
      ></progress-bar>
      <section>
        <v-layout align-center column justify-center>
          <a class="mt-7" href="/">
            <img
              :src="
                $vuetify.theme.dark
                  ? '/../../img/logo/ls-h-branco.svg'
                  : '/../../img/logo/ls-h-azul.svg'
              "
              height="30"
              width="160"
              alt="Logo da Lucas Silva Educação"
            />
          </a>
        </v-layout>
        <v-layout align-center class="black--text" column justify-center>
        </v-layout>
      </section>
      <v-container class="pa-1 d-flex justify-center mt-1" fluid>
        <v-layout row wrap id="v-layout">
          <v-flex lg8 md7 sm12 xs12>
            <div id="left-side" v-bind:class="{ blocked: closing }">
              <v-stepper
                v-model="step"
                alt-labels
                class="v-card--flat"
                :style="
                  $vuetify.theme.dark
                    ? 'background-color: #121212'
                    : 'background-color: transparent'
                "
              >
                <v-stepper-header style="box-shadow: none; margin-bottom: 16px">
                  <v-stepper-step :complete="step > 1" step="1" class="pb-0"
                    >Identificação</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step :complete="step > 2" step="2" class="pb-0"
                    >Pagamento</v-stepper-step
                  >
                  <v-divider></v-divider>
                  <v-stepper-step :complete="step > 3" step="3" class="pb-0"
                    >Confirmação</v-stepper-step
                  >
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content class="pt-0" step="1">
                    <v-card
                      :loading="closing"
                      class="mb-1 pt-0 pefil-card"
                      :class="this.$vuetify.theme.isDark ? 'dark' : undefined"
                      color="lighten-1"
                      flat
                    >
                      <v-container
                        grid-list-md
                        style="
                          display: flex;
                          align-items: center;
                          flex-direction: column;
                        "
                      >
                        <login-form
                          v-if="!authenticated"
                          hide-remember="true"
                          checkout="true"
                          redirect=""
                        >
                        </login-form>
                        <profile-form
                          v-model:loading="formBtnLoading"
                          ref="profileForm"
                          v-else
                          :model="user"
                          :loading="formBtnLoading"
                          :profile-image="false"
                          :full-documentation="fullDocumentation"
                          :rg-required="true"
                          submit-label="Avançar"
                          :showBtnOnCheckout="!isMobile"
                          @submit="gotoPaymentStep"
                        >
                        </profile-form>
                      </v-container>

                      <v-card-actions class> </v-card-actions>
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-content class="pt-0" step="2">
                    <div v-if="this.order.net_amount != 0">
                      <div
                        v-if="this.order.net_amount > 0"
                        id="BodyPaymentMethods"
                      >
                        <v-flex class="py-2" sm12 xs12>
                          <v-card class="mt-0" flat>
                            <v-bottom-navigation
                              style="
                                display: flex;
                                align-items: center;
                                gap: 15px;
                                height: 76px !important;
                                box-shadow: none;
                              "
                              :style="
                                $vuetify.theme.dark
                                  ? 'background-color: #121212'
                                  : 'background-color: transparent'
                              "
                              v-model="paymentMethod"
                              :value="true"
                              flat
                              @change="onSelectPaymentMethod()"
                            >
                              <v-btn
                                v-for="availablePaymentMethod in availablePaymentMethods"
                                :key="availablePaymentMethod.identifier"
                                :disabled="closing"
                                class="payment-methods pa-3"
                                active-class="payment-methods active"
                                :value="availablePaymentMethod.identifier"
                              >
                                <span class="pb-3">{{
                                  availablePaymentMethod.display_text
                                }}</span>
                                <v-img
                                  class="ma-2"
                                  contain
                                  :src="availablePaymentMethod.icon"
                                  width="30"
                                />
                              </v-btn>
                            </v-bottom-navigation>
                          </v-card>
                          <!--</v-layout>-->
                        </v-flex>
                      </div>
                      <v-card
                        class="pt-6"
                        v-if="paymentMethod === 'credit_card'"
                        ref="creditCard"
                        flat
                        :style="
                          $vuetify.theme.dark
                            ? 'background-color: #121212'
                            : 'background-color: transparent'
                        "
                      >
                        <credit-card
                          :credit-card="this.card"
                          :disabled="this.closing"
                          :is-valid="this.creditCardValid"
                          :available_installments="this.installments"
                          @isCardValid="onCardReady"
                          @onInstallmentChange="onSelectInstallment"
                        >
                        </credit-card>
                      </v-card>
                      <div
                        v-else
                        :ref="paymentMethod"
                        class="pt-6"
                        style="display: flex; justify-content: center"
                      >
                        <payment-installments
                          :key="paymentMethod"
                          :installments="this.installments"
                          @onInstallmentChange="onSelectInstallment"
                        >
                        </payment-installments>
                      </div>
                    </div>

                    <v-card
                      id="navButtons"
                      :loading="this.closing"
                      class="pa-0 mt-5"
                      flat
                    >
                      <v-card-actions
                        :style="
                          $vuetify.theme.dark
                            ? 'background-color: #121212'
                            : 'background-color: transparent'
                        "
                      >
                        <v-btn depressed text @click="voltarBtnClick()"
                          >Voltar</v-btn
                        >
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-stepper-content>
                  <v-stepper-content
                    class="pt-0"
                    step="3"
                    v-if="order.items.data"
                  >
                    <thankyou
                      :order="order"
                      :transaction="transaction"
                    ></thankyou>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </div>
          </v-flex>
          <v-flex lg4 md5 sm12 xs12>
            <div
              id="summary"
              :class="this.$vuetify.theme.isDark ? 'dark' : undefined"
            >
              <order-summary
                :coupon-enabled="step !== 3"
                :order="this.order"
                :courseRecommendation="courseRecommendation"
                @courseRecommendationChanged="courseRecommendation = $event"
                @orderChanged="order = $event"
                :installments="installments"
                @installmentsChanged="installments = $event"
                :selectedInstallment="selectedInstallment"
                @selectedInstallmentChanged="selectedInstallment = $event"
                @couponApplied="onCouponApplied"
                @updateOrder="onUpdateOrder"
                :showChargeButton="showChargeButton"
                :showAvancarButton="showAvancarButton"
                :disableChargeButton="disableChargeButton"
                @disableChargeButtonChanged="disableChargeButton = $event"
                :ctaPayment="CtaPayment"
                :loadingAvancarButton="formBtnLoading"
                @ctaPaymentChanged="CtaPayment = $event"
                @fakeClick="avancarFakeClick"
                @charged="charge"
              >
              </order-summary>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <exit-intent-dialog
        :show="this.showExitIntentDiaglog"
        @close="onCloseExitIntent"
      ></exit-intent-dialog>
      <animation-card :show-overlay="animationDone"></animation-card>
      <animation-card-video
        :show-overlay="animationDone2"
        :checkoutVideoUrl="checkoutVideoUrl"
      ></animation-card-video>
    </v-container>
  </v-app>
</template>
<script>
import OrdersServices from "../../../services/orders.service";
import UserService from "@/services/users.service";
import { CONFIG } from "@/config";
import OrderSummary from "../OrderSummary";
import LoginForm from "../../../components/widgets/form/LoginForm";
import { mapGetters } from "vuex";
import LoggedForm from "../../../components/widgets/form/LoggedForm";
import ProfileForm from "../../../components/widgets/form/ProfileForm";
import CreditCard from "./CreditCard";
import Util from "@/util";
import Thankyou from "../Thankyou";
import ExitIntentDialog from "../../../components/widgets/dialog/ExitIntentDialog";
import Cookies from "js-cookie";
import AnimationCard from "../../../components/widgets/card/AnimationCard";
import AnimationCardVideo from "../../../components/widgets/card/AnimationCardVideo";
import PaymentInstallments from "./PaymentInstallments";
import SharkAffiliate from "../../../util/shark-affiliate";

export default {
  components: {
    PaymentInstallments,
    AnimationCard,
    AnimationCardVideo,
    ExitIntentDialog,
    Thankyou,
    CreditCard,
    ProfileForm,
    LoggedForm,
    LoginForm,
    OrderSummary,
  },
  data() {
    return {
      showChargeButton: false,
      transaction: null,
      selectedInstallment: null,
      selectedInstallmentAmount: null,
      CtaPayment: "Finalizar Compra",
      paymentMethod: "credit_card",
      card: {
        cardName: "",
        cardNumber: "",
        cardMonth: "",
        cardYear: "",
        cardCvv: "",
        brand: "",
        selectedInstallment: null,
        maxInstallmentNoInterest: parseInt(
          process.env.MIX_MAX_INSTALLMENT_NO_INTEREST,
        ),
        installments: [],
        token: "",
      },
      step: 1,
      order: {
        items: {
          data: [],
        },
      },
      checkoutVideoUrl: "",
      fullDocumentation: false,
      creditCardValid: false,
      haveCoupon: false,
      code: "",
      animationDone: false,
      animationDone2: false,
      closing: false,
      loading: true,
      disableChargeButton: true,
      showExitIntentDiaglog: false,
      availablePaymentMethods: [
        {
          identifier: String,
          display_text: String,
          icon: String,
          conditions: [],
        },
      ],
      installments: [],
      formBtnLoading: false,
      courseRecommendation: null,
      isMobile: window.innerWidth <= 500,
    };
  },
  watch: {
    step(newStep) {
      if (newStep === 3) {
        this.courseRecommendation = false;
      }
    },
  },
  mounted() {
    this.loadOrder();
    this.resetCardData();
  },
  metaInfo() {
    return {
      title: "LS - Cursos de Certificações Disponíveis",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Todos os cursos de certificação disponíveis do Prof Lucas Silva. CPA-10, CPA-20, CEA, CFP, ANCORD, HP",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: "authUser",
      authenticated: "authCheck",
    }),
    showAvancarButton() {
      return this.step === 1;
    },
  },
  methods: {
    resetCardData() {
      this.cardData = {
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        brand: "",
        selectedInstallment: null,
        maxInstallmentNoInterest: parseInt(
          process.env.MIX_MAX_INSTALLMENT_NO_INTEREST,
        ),
        installments: [],
        token: "",
      };
      return this.card;
    },

    async onSelectInstallment(selectedInstallment) {
      this.selectedInstallment = selectedInstallment;
      if (selectedInstallment !== undefined) {
        if (
          this.order &&
          this.order.net_amount !== this.selectedInstallment.totalAmount
        ) {
          this.loading = true;
          const response = await OrdersServices.updateOrderPaymentPlan(
            this.order.id,
            this.selectedInstallment.identifier,
            this.selectedInstallment.quantity,
            this.paymentMethod,
          );
          this.order = response.data;
          this.loading = false;
        }
        this.onSelectPaymentMethod();
      }
    },

    getCTAInstallmentLabel(paymentMethod) {
      const paymentMethodText = "no " + paymentMethod;
      if (this.selectedInstallment) {
        if (this.selectedInstallment.quantity === 1) {
          return " à vista " + paymentMethodText;
        }
        return (
          "em " + this.selectedInstallment.quantity + "x " + paymentMethodText
        );
      }
      return " " + paymentMethodText;
    },

    onSelectPaymentMethod() {
      switch (this.paymentMethod) {
        case "boleto":
          this.syncInstallmentsWithPaymentMethod();
          this.disableChargeButton = false;
          this.CtaPayment = this.getCTAInstallmentLabel("boleto");
          break;
        case "credit_card":
          this.syncInstallmentsWithPaymentMethod();
          this.disableChargeButton = !this.creditCardValid;
          this.CtaPayment = this.getCTAInstallmentLabel("cartão");
          break;
        case "pix":
          this.syncInstallmentsWithPaymentMethod();
          this.disableChargeButton = false;
          this.CtaPayment = this.getCTAInstallmentLabel("pix");
          break;
      }
    },
    async loadOrder() {
      this.loading = true;

      try {
        const response = await OrdersServices.getOrder(
          this.$route.params.orderId,
        );
        this.order = response.data;
        this.checkoutVideoUrl =
          this.order.items.data[0].saleable.checkout_video_url;
        this.fullDocumentation = this.order.items.data[0].saleable.rg_required;
        await this.loadAvailablePaymentMethods(this.order.id);
        this.onSelectPaymentMethod();
        this.createFacebookInitiateCheckout(this.order);
        this.setAnalyticsBeginCheckout(this.order);
        this.setAnalyticsActionCheckout(this.order, 1);
        this.ifOrderAmountZero();
        this.loading = false;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          window.getApp.sendSnackMessage(
            "Pedido finalizado. Por favor, repita o processo de compra",
            "error",
          );
          this.$router.push("/shopping");
        } else {
          console.error("Error loading order:", error);
          this.$router.push("/shopping");
        }
        this.loading = false;
      }
    },
    async updateProfile(model) {
      delete model.avatar;
      this.formBtnLoading = true;
      try {
        await UserService.updateProfile(model); // Wait for profile update
        const affiliateRef = SharkAffiliate.getAffiliateRefFromCookie();
        await OrdersServices.updateOrder(this.order.id, affiliateRef);
      } catch (error) {
        this.formBtnLoading = false;
        window.getApp.sendSnackMessage(error.message, "error");
        throw new Error(
          "Failed to update profile and/or order: " + error.message,
        );
      }
      this.formBtnLoading = false;
    },
    async gotoPaymentStep() {
      if (this.order.user) {
        if (this.order.user.id !== this.user.id) {
          console.warn("Usuario logado diferente do usuário do pedido");
          OrdersServices.resetCoupon(this.$route.params.orderId).then(
            (response) => {
              this.order = response.data;
              this.loading = false;
            },
          );
        }
      }

      try {
        await this.updateProfile(this.user);
        this.addCourseRecommendation();
        this.createFacebookAddToCartCheckout(this.order);
        this.setAnalyticsActionCheckout(this.order, 2);
        this.step = 2;
        this.showChargeButton = true;
        this.$vuetify.goTo(0);
      } catch (error) {}
    },

    onCardReady(e) {
      this.creditCardValid = e;
      this.disableChargeButton = !e;
    },
    showAnimationDone() {
      this.animationDone = true;
      const _this = this;
      setTimeout(function () {
        _this.animationDone = false;
        _this.animationDone2 = true;
      }, 3000);
    },
    avancarFakeClick() {
      if (this.$refs.profileForm) {
        this.$refs.profileForm.submit();
      }
    },
    async charge() {
      let _this = this;
      _this.disableChargeButton = true;
      try {
        window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute(CONFIG.CAPTCHA_SITE_KEY, { action: "submit" })
          .then(async function (token) {

            _this.closing = !_this.closing;
            if (_this.order.net_amount === 0) {
              _this.redeemFullCoupon();
              _this.createAnalyticsPurchase(_this.order);
              _this.disableChargeButton = true;
              return;
            }

            const paymentPlan = {
              id: _this.selectedInstallment.identifier,
              chosen_installments: _this.selectedInstallment.quantity,
              payment: {
                method: _this.paymentMethod,
              },
            };
            _this.setAnalyticsPayment(_this.order, _this.paymentMethod);

            if (_this.paymentMethod === "credit_card") {
              paymentPlan.payment = {
                ...paymentPlan.payment,
                ...{
                  card: {
                    card_hash: await OrdersServices.createCardHash({
                      card_holder_name: _this.card.cardName,
                      card_number: _this.card.cardNumber.replace(/\s/g, ""),
                      card_expiration_date:
                        _this.card.cardMonth +
                        _this.card.cardYear.toString().slice(2),
                      card_cvv: _this.card.cardCvv,
                    }),
                  },
                },
              };
            }
            try {
              paymentPlan.captcha_token = token;

              const response = await OrdersServices.createPagarmePurchase(
                _this.order.id,
                paymentPlan,
              );

              _this.transaction = response.data;
              _this.showChargeButton = false;

              if (
                _this.transaction.is_paid ||
                _this.paymentMethod !== "credit_card"
              ) {
                _this.showAnimationDone();
                _this.step = 3;
              } else {
                console.error("error", _this.transaction);
                window.getApp.sendSnackMessage(
                  _this.transaction.message,
                  "error",
                );
                _this.showChargeButton = true;
                _this.closing = false;
              }

              _this.createFacebookPurchase(_this.order);
              _this.createAnalyticsPurchase(_this.order);
              _this.closing = false;
            } catch (error) {
              window.getApp.sendSnackMessage(error.message, "error", 30000);
              _this.showChargeButton = true;
              _this.disableChargeButton = false;
              _this.closing = false;
            }
          })
          .catch(error => {
            console.error('erro execute recaptcha', error)
            this.closing = false;
            window.getApp()
              .sendSnackMessage("Problema ao carregar checkout. Por favor, recarrega a página.", "error");
          });
        });
      } catch (error) {
        console.error('erro ready recaptcha', error);
        this.closing = false;
        window.getApp()
          .sendSnackMessage("Problema ao inicializar checkout. Por favor, recarrega a página.", "error");
      }

    },
    redeemFullCoupon() {
      this.closing = true;
      OrdersServices.redeemFullProductCoupon(this.order.id)
        .then((res) => {
          this.transaction = {
            gateway: "grátis",
            id: null,
            installments: "1",
            net_amount: "Grátis",
            order_id: this.order.id,
            payment_method_id: null,
          };
          this.step = 3;
          this.closing = false;
        })
        .catch((error) => {
          this.closing = false;
          console.error('erro ao regastar cupom presente', error);
          window.getApp().sendSnackMessage("Problema ao resgatar o produto", "error");
        });
    },
    startLoading() {
      this.loading = true;
    },
    finishLoading() {
      this.loading = false;
    },
    voltarBtnClick() {
      this.step = 1;
      this.showChargeButton = false;
    },
    async onCouponApplied(order) {
      this.startLoading();
      this.order = order;
      await this.loadAvailablePaymentMethods(order.id);
      this.onSelectPaymentMethod();
      this.setAnalyticsCoupon(order);
      this.finishLoading();
      this.ifOrderAmountZero();
      window.getApp.sendSnackMessage(
        `Cupom aplicado com sucesso! 💰`,
        "success",
      );
    },
    ifOrderAmountZero() {
      if (this.order.net_amount === 0) {
        this.disableChargeButton = false;
        this.selectedInstallment = true;
      }
    },
    async onUpdateOrder(order) {
      this.startLoading();
      this.order = order;
      await this.loadAvailablePaymentMethods(order.id);
      this.onSelectPaymentMethod();
      this.ifOrderAmountZero();
      this.finishLoading();
    },
    addCourseRecommendation() {
      OrdersServices.getCourseRecommendation(this.order.id)
        .then((response) => {
          this.courseRecommendation = response.data;
        })
        .catch((err) => {
          window.getApp.sendSnackMessage(err.message, "error");
        });
    },
    onLeave(e) {
      if (e.clientY < 1 && this.step < 3) {
        if (!Cookies.get("IseeShark")) {
          Cookies.set("IseeShark", "1", { expires: 1 });
          this.showExitIntentDiaglog = true;
        }
      }
    },
    onCloseExitIntent() {
      this.showExitIntentDiaglog = false;
    },
    createFacebookInitiateCheckout(order) {
      const course = order.items.data[0].saleable;
      window.fbq("track", "InitiateCheckout", {
        value: course.price,
        currency: "BRL",
      });
    },
    createFacebookAddToCartCheckout(order) {
      const course = order.items.data[0].saleable;
      window.fbq("track", "AddPaymentInfo", {
        value: course.price,
        currency: "BRL",
      });
    },

    createFacebookPurchase(order) {
      const course = order.items.data[0].saleable;
      window.fbq("track", "Purchase", { value: course.price, currency: "BRL" });
    },

    createAnalyticsPurchase(order) {
      try {
        const courses = order.items.data.map((item) => item);
        let coupon = "";
        if (order.coupon) coupon = order.coupon;
        const items = courses.map((course) => ({
          id: course.saleable.id,
          name: course.saleable.course,
          sku: course.saleable.id,
          category: "Videoaula",
          price: parseFloat(course.net_amount),
          discount: parseFloat(course.discount_amount),
          coupon: coupon,
          quantity: "1",
        }));

        this.$gtag.query("event", "purchase", {
          value: order.net_amount,
          currency: "BRL",
          transaction_id: order.id,
          items: items,
        });

        this.$gtag.pageview(this.$route);
      } catch (error) {
        console.error("Error in createAnalyticsPurchase:", error);
      }
    },

    setAnalyticsBeginCheckout(order) {
      try {
        const course = order.items.data[0].saleable;
        let coupon = "";

        if (order.coupon) {
          coupon = order.coupon;
        }

        this.$gtag.query("event", "begin_checkout", {
          currency: "BRL",
          value: order.net_amount,
          coupon: coupon,
          items: [
            {
              item_id: order.id,
              item_name: course.course,
              coupon: coupon,
              item_category: "Videoaula",
              price: order.net_amount,
              quantity: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsBeginCheckout:", error);
      }
    },
    setAnalyticsPayment(order, payMethod) {
      try {
        const course = order.items.data[0].saleable;
        let coupon = "";
        if (order.coupon) coupon = order.coupon;

        this.$gtag.query("event", "add_payment_info", {
          currency: "BRL",
          value: order.net_amount,
          coupon: coupon,
          payment_type: payMethod,
          items: [
            {
              item_id: order.id,
              item_name: course.course,
              coupon: coupon,
              item_category: "Videoaula",
              price: order.net_amount,
              quantity: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsPayment:", error);
      }
    },
    setAnalyticsCoupon(order) {
      try {
        const course = order.items.data[0].saleable;
        const orderItem = order.items.data[0];
        const discount = parseFloat(orderItem.discount_amount);
        const coursePrice = parseFloat(course.price);
        const value = coursePrice - discount;
        this.$gtag.query("event", "add_coupon", {
          coupon: order.coupon,
          items: [
            {
              item_id: order.id,
              item_name: course.course,
              coupon: order.coupon,
              item_category: "Videoaula",
              discount: discount,
              price: value,
              quantity: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsCoupon:", error);
      }
    },
    setAnalyticsAddToCart(order) {
      try {
        const course = order.items.data[0].saleable;
        const orderItem = order.items.data[0];
        const discount = parseFloat(orderItem.discount_amount);
        const coursePrice = parseFloat(course.price);
        const value = coursePrice - discount;

        this.$gtag.query("event", "add_to_cart", {
          value: value,
          currency: "BRL",
          items: [
            {
              id: order.id,
              name: course.course,
              sku: course.id,
              category: "Videoaula",
              discount: discount,
              price: value,
              quantity: "1",
            },
          ],
        });
      } catch (error) {
        console.error("Error in setAnalyticsAddToCart:", error);
      }
    },

    setAnalyticsActionCheckout(order, stepNumber, option = "") {
      try {
        const course = order.items.data[0].saleable;
        const orderItem = order.items.data[0];
        const discount = parseFloat(orderItem.discount_amount);
        const coursePrice = parseFloat(course.price);
        const value = coursePrice - discount;

        if (stepNumber === 1) {
          this.setAnalyticsAddToCart(order);
        }

        this.$gtag.query("event", "checkout_progress", {
          step: stepNumber,
          option: option,
          items: [
            {
              id: order.id,
              name: course.course,
              sku: course.id,
              category: "Videoaula",
              price: value,
              quantity: "1",
            },
          ],
        });

        this.$gtag.pageview(this.$route);
      } catch (error) {
        console.error("Error in setAnalyticsActionCheckout:", error);
      }
    },
    syncInstallmentsWithPaymentMethod() {
      try {
        this.installments =
          this.availablePaymentMethods[`${this.paymentMethod}`].conditions;
      } catch (error) {
        const [first] = Object.keys(this.availablePaymentMethods);
        this.paymentMethod = first;
        this.installments =
          this.availablePaymentMethods[`${this.paymentMethod}`].conditions;
      }
    },

    async loadAvailablePaymentMethods(orderId) {
      this.startLoading();
      const response = await OrdersServices.getAvailablePaymentMethods(orderId);
      this.availablePaymentMethods = response.data;
      this.syncInstallmentsWithPaymentMethod();
      this.finishLoading();
    },
  },
};
</script>
<style lang="scss" scoped>
#v-layout {
  max-width: 1440px;
}

.pefil-card.dark,
.pefil-card.dark > * {
  background: transparent !important;
}

.dark .pa-2 {
  background-color: transparent !important;
}
.blocked {
  pointer-events: none;
}

#summary.dark {
  background-color: #2d2d2d !important;
  @media (max-width: 850px) {
    background-color: transparent !important;
  }
}

#summary.dark .pa-2.v-card.v-card--flat.v-sheet {
  background: transparent !important;
}

#summary {
  height: 100vh;
  z-index: 0;
  background-size: cover;
  background-color: #f5f5f5 !important;
  border-radius: 35px 35px 0 0;
  @media (max-width: 960px) {
    height: 100%;
  }
  @media (max-width: 850px) {
    background-color: transparent !important;
  }
}

.v-stepper {
  box-shadow: none;
}

#left-side {
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  overflow: hidden;
  background-color: transparent !important;
  padding: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
.payment-methods {
  border-radius: 15px !important;
  border: 1px solid grey;
  &.active {
    border: 2px solid var(--v-primary-base);
  }
}

@-webkit-keyframes swing {
  15% {
    -webkit-transform: translateX(15px);
    transform: translateX(15px);
  }
  30% {
    -webkit-transform: translateX(-15px);
    transform: translateX(-15px);
  }
  50% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  65% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
  80% {
    -webkit-transform: translateX(3px);
    transform: translateX(3px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}

@keyframes swing {
  15% {
    -webkit-transform: translateX(15px);
    transform: translateX(15px);
  }
  30% {
    -webkit-transform: translateX(-15px);
    transform: translateX(-15px);
  }
  50% {
    -webkit-transform: translateX(8px);
    transform: translateX(8px);
  }
  65% {
    -webkit-transform: translateX(-8px);
    transform: translateX(-8px);
  }
  80% {
    -webkit-transform: translateX(3px);
    transform: translateX(3px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
</style>
